"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasMoreSentPackages = void 0;
var hasMoreSentPackages = function (store) {
    return store.sentPackages.packages.length < store.sentPackages.totalPackagesCount;
};
exports.hasMoreSentPackages = hasMoreSentPackages;
